var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2012 22.7466C60.2662 21.6816 60.2662 19.9548 59.2012 18.8897L41.8448 1.53342C40.7798 0.468351 39.0532 0.468354 37.9879 1.53342C36.9229 2.5985 36.9229 4.3253 37.9879 5.39035L53.4158 20.8182L37.9879 36.2461C36.9229 37.3111 36.9229 39.0377 37.9879 40.103C39.0532 41.168 40.7798 41.168 41.8448 40.103L59.2012 22.7466ZM4.76852e-07 23.5454H57.2727V18.0909H0L4.76852e-07 23.5454Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.a7a58d593eed996092f090f2619e8884.svg";
export { ForwardRef as ReactComponent };